import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gtd-crm-percent',
  templateUrl: './crm-percent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmPercentComponent {
  @Input() customClass = '';
  @Input() set data(data: number | string | any) {
    this.value = isNaN(data) ? '0.00' : Number(data).toFixed(Number(data) >= 1000 ? 0 : 2);
  }
  public value: string;
}
